// extracted by mini-css-extract-plugin
module.exports = {"tile":"BookTile_tile__3TxGn","disabled":"BookTile_disabled__k5Stf"};